import { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import { saveProjectDetails } from "../Api/ProjectMaster";
import { Container, Form, Button, Row, Col, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import {
  fetchCustomersByOrgId,
  fetchProjectTypes,
  fetchResourceByOrgId,
  fetchCompanyCodesById,
} from "../Api/InvoiceApi";
import { useAuth } from "../Context/AuthContext";
import axios from "axios";
import { Base_URL } from "../url";
import { getTeamsWithMembersByOrg } from "../Api/TeamMaster";
import Select from "react-select";
import { FaUsers, FaInfoCircle } from "react-icons/fa";

const ProjectMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [hoveredTeam, setHoveredTeam] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const teamSelectRef = useRef(null);
  const hoverTimeoutRef = useRef(null);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const orgId = userDetails?.organisationId;

  const [customer, setCustomer] = useState([]);
  const [projectType, setProjectType] = useState([]);
  const [resource, setResource] = useState([]);
  const [company, setCompany] = useState([]);
  const [status, setStatus] = useState([]);

  const { user } = useAuth();

  const [projectData, setProjectData] = useState({
    prTitle: "",
    prDescription: "",
    prTags: "",
    prStartDate: "",
    prEndDate: "",
    prClient: "",
    prTypes: "",
    usersId: String(userId) || "",
    orgId: String(orgId) || "",
    teamAssigned: "",
    projectStatus: "",
    projectCategory: "",
    comments: "",
    salespersonCode: "",
    currentProjectManager: "",
    organisationId: user?.organisationId,
    companyCode: "",
    projectPriority: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProjectData((prev) => ({ ...prev, [name]: value }));
  };

  const fetchDropdownData = async () => {
    try {
      const res = await fetchCustomersByOrgId(user?.organisationId);
      const res1 = await fetchProjectTypes(user?.organisationId);
      const res2 = await fetchResourceByOrgId(user?.organisationId);
      const res3 = await fetchCompanyCodesById(user?.organisationId);
      const res4 = await axios.get(`${Base_URL}/ProjectStatus`);
      const teamsData = await getTeamsWithMembersByOrg(user?.organisationId);

      setCustomer(res || []);
      setProjectType(res1 || []);
      setResource(res2 || []);
      setCompany(res3 || []);
      setStatus(res4.data || []);
      setTeams(teamsData || []);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
      setCustomer([]);
      setProjectType([]);
      setResource([]);
      setCompany([]);
      setStatus([]);
      setTeams([]);
    }
  };

  useEffect(() => {
    fetchDropdownData();
  }, []);

  // Prepare options for React Select
  const teamOptions = teams.map((team) => ({
    value: team.teamId,
    label: `${team.teamName} (${team.members?.length || 0} members)`,
    teamData: team,
  }));

  // Handle team selection
  const handleTeamChange = (selectedOption) => {
    setSelectedTeam(selectedOption);
    setProjectData((prev) => ({
      ...prev,
      teamAssigned: selectedOption?.value || "",
    }));
    // Close tooltip when team is selected
    setHoveredTeam(null);
  };

  // Handle mouse enter for tooltip with position calculation
  const handleMouseEnter = (event, teamData) => {
    // Clear any existing timeout
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }

    const rect = event.currentTarget.getBoundingClientRect();
    setTooltipPosition({
      top: rect.top - 10,
      left: rect.left + rect.width + 10,
    });
    setHoveredTeam(teamData);
  };

  const handleMouseLeave = () => {
    // Add a small delay before hiding to prevent flickering
    hoverTimeoutRef.current = setTimeout(() => {
      setHoveredTeam(null);
    }, 100);
  };

  // Handle dropdown open/close
  const handleMenuOpen = () => {
    setIsDropdownOpen(true);
  };

  const handleMenuClose = () => {
    setIsDropdownOpen(false);
    // Close tooltip when dropdown closes
    setHoveredTeam(null);
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
  };

  // Custom option component with hover tooltip
  const CustomOption = (props) => {
    const { data, innerRef, innerProps, isFocused } = props;

    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          padding: "10px",
          backgroundColor: isFocused ? "#f0f0f0" : "white",
          cursor: "pointer",
          position: "relative",
        }}
        onMouseEnter={(e) => handleMouseEnter(e, data.teamData)}
        onMouseLeave={handleMouseLeave}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>
            <FaUsers style={{ marginRight: "8px", color: "#007bff" }} />
            {data.label}
          </span>
          <FaInfoCircle style={{ color: "#6c757d", fontSize: "12px" }} />
        </div>
      </div>
    );
  };

  // Custom single value display
  const CustomSingleValue = ({ data }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <FaUsers style={{ marginRight: "8px", color: "#007bff" }} />
      <span>{data.label}</span>
    </div>
  );

  // Render team members tooltip
  const renderTeamMembersTooltip = (team) => {
    if (!team) return null;

    return (
      <Card
        style={{
          backgroundColor: "white",
          border: "1px solid #ddd",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          minWidth: "320px",
          maxWidth: "450px",
        }}
      >
        <Card.Header
          style={{
            backgroundColor: "#007bff",
            color: "white",
            fontWeight: "bold",
            padding: "10px 15px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <FaUsers />
            <span>
              {team.teamName} - Members ({team.members?.length || 0})
            </span>
          </div>
        </Card.Header>
        <Card.Body
          style={{ maxHeight: "350px", overflowY: "auto", padding: "10px" }}
        >
          {team.members && team.members.length > 0 ? (
            <div style={{ fontSize: "13px" }}>
              {team.members.map((member, index) => (
                <div
                  key={member.memberId}
                  style={{
                    padding: "10px",
                    borderBottom:
                      index < team.members.length - 1
                        ? "1px solid #e9ecef"
                        : "none",
                    transition: "background-color 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        backgroundColor: "#e9ecef",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "bold",
                        color: "#495057",
                      }}
                    >
                      {member.memberId || index + 1}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "600", color: "#212529" }}>
                        {member.memberName}
                      </div>
                      {member.emailId && (
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#6c757d",
                            marginTop: "2px",
                          }}
                        >
                          {member.emailId}
                        </div>
                      )}
                      {member.phoneNumber && (
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#6c757d",
                            marginTop: "2px",
                          }}
                        >
                          📞 {member.phoneNumber}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p
              style={{
                textAlign: "center",
                color: "#999",
                margin: 0,
                padding: "20px",
              }}
            >
              No members in this team
            </p>
          )}
        </Card.Body>
      </Card>
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await saveProjectDetails(projectData, userId);

      // Display success message with project ID and name
      if (response && response.projectId && response.projectName) {
        toast.success(
          <div>
            <strong>✅ Project Created Successfully!</strong>
            <br />
            <span>
              📋 Project ID: <strong>{response.projectId}</strong>
            </span>
            <br />
            <span>
              📝 Project Name: <strong>{response.projectName}</strong>
            </span>
          </div>,
          {
            autoClose: 5000,
            position: "top-right",
          },
        );
      } else {
        toast.success("🦄 Project Added Successfully");
      }

      console.log("API Response:", response);
      console.log("Submitted Project Data:", projectData);

      // Reset form after successful submission
      setProjectData({
        prTitle: "",
        prDescription: "",
        prTags: "",
        prStartDate: "",
        prEndDate: "",
        prClient: "",
        prTypes: "",
        usersId: String(userId) || "",
        orgId: String(orgId) || "",
        teamAssigned: "",
        projectStatus: "",
        projectCategory: "",
        comments: "",
        salespersonCode: "",
        currentProjectManager: "",
        organisationId: user?.organisationId,
        companyCode: "",
        projectPriority: "",
      });
      setSelectedTeam(null);

      // Navigate after a short delay to show the success message
      setTimeout(() => {
        navigate("/viewProjects");
      }, 2000);
    } catch (error) {
      toast.error(`🦄 Error saving project: ${error.message || error}`);
      console.error("Save error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Add animation styles
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes fadeIn {
        from {
          opacity: 0;
          transform: translateX(-10px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <h2 className="fields-title">Project Master</h2>

        {loading && (
          <div className="loading-overlay">
            <Sample14 />
          </div>
        )}

        {/* Tooltip rendered via Portal to avoid layout shift */}
        {hoveredTeam &&
          isDropdownOpen &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                top: tooltipPosition.top,
                left: tooltipPosition.left,
                animation: "fadeIn 0.2s ease-in-out",
              }}
              onMouseEnter={() => {
                if (hoverTimeoutRef.current) {
                  clearTimeout(hoverTimeoutRef.current);
                }
              }}
              onMouseLeave={() => {
                setHoveredTeam(null);
              }}
            >
              {renderTeamMembersTooltip(hoveredTeam)}
            </div>,
            document.body,
          )}

        <Form onSubmit={handleSubmit} className="fields-form">
          {/* ---- Company Code ---- */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Company Code <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="companyCode"
                  value={projectData.companyCode}
                  onChange={handleChange}
                  required
                  disabled={!user?.organisationId}
                >
                  <option value="">Select Company Code</option>
                  {company.map((p) => (
                    <option key={p.companyCode} value={p.companyCode}>
                      {p.companyCode} - {p.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Category <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="projectCategory"
                  value={projectData.projectCategory}
                  onChange={(e) => {
                    const value = e.target.value;
                    setProjectData((prev) => ({
                      ...prev,
                      projectCategory: value,
                      prClient: value === "Internal" ? "" : prev.prClient,
                      salespersonCode:
                        value === "Internal" ? "" : prev.salespersonCode,
                    }));
                  }}
                  required
                >
                  <option value="">Select Category</option>
                  <option value="Internal">Internal</option>
                  <option value="External">External</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* ---- Basic Details ---- */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Project Title <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="prTitle"
                  value={projectData.prTitle}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Project Description <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="prDescription"
                  value={projectData.prDescription}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Project Tags</Form.Label>
                <Form.Control
                  type="text"
                  name="prTags"
                  value={projectData.prTags}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* ---- Dates ---- */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Start Date <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="prStartDate"
                  value={projectData.prStartDate}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  End Date <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="prEndDate"
                  value={projectData.prEndDate}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {projectData.projectCategory !== "Internal" && (
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Client Code <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Select
                    name="prClient"
                    value={projectData.prClient}
                    onChange={handleChange}
                    required={projectData.projectCategory === "External"}
                    disabled={!user?.organisationId}
                  >
                    <option value="">Select Client Code</option>
                    {customer.map((c) => (
                      <option key={c.customerCode} value={c.customerCode}>
                        {c.customerCode} - {c.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}
          </Row>

          {/* ---- Type, Team, Priority ---- */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Project Type <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="prTypes"
                  value={projectData.prTypes}
                  onChange={handleChange}
                  required
                  disabled={!user?.organisationId}
                >
                  <option value="">Select Project Type</option>
                  {projectType.map((p) => (
                    <option key={p.projectTypeId} value={p.projectTypeId}>
                      {p.projectTypeId} - {p.projectTypeDesc}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Team Assigned</Form.Label>
                <div ref={teamSelectRef}>
                  <Select
                    options={teamOptions}
                    value={selectedTeam}
                    onChange={handleTeamChange}
                    onMenuOpen={handleMenuOpen}
                    onMenuClose={handleMenuClose}
                    placeholder="Select a team..."
                    isClearable
                    components={{
                      Option: CustomOption,
                      SingleValue: CustomSingleValue,
                    }}
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "38px",
                        borderColor: "#ced4da",
                        "&:hover": {
                          borderColor: "#86b7fe",
                        },
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                        "&:active": {
                          backgroundColor: "#e0e0e0",
                        },
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 9998,
                      }),
                    }}
                  />
                </div>
                <small className="text-muted">
                  Hover over any team to see its members
                </small>
              </Form.Group>
            </Col>

            {/* Project Priority Dropdown */}
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Project Priority <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="projectPriority"
                  value={projectData.projectPriority}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Priority</option>
                  <option value="Very High">Very High</option>
                  <option value="High">High</option>
                  <option value="Medium">Medium</option>
                  <option value="Low">Low</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* ---- Remaining Fields ---- */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Status <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="projectStatus"
                  value={projectData.projectStatus}
                  onChange={handleChange}
                  required
                  disabled={!user?.organisationId}
                >
                  <option value="">Select Project Status</option>
                  {status.map((p) => (
                    <option key={p.projectStatusId} value={p.projectStatusId}>
                      {p.projectStatusId} - {p.projectStatusDesc}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Comments</Form.Label>
                <Form.Control
                  type="text"
                  name="comments"
                  value={projectData.comments}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {projectData.projectCategory !== "Internal" && (
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Salesperson Code <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Select
                    name="salespersonCode"
                    value={projectData.salespersonCode}
                    onChange={handleChange}
                    required={projectData.projectCategory === "External"}
                    disabled={!user?.organisationId}
                  >
                    <option value="">Select SalesPerson Code</option>
                    {resource.map((r) => (
                      <option key={r.resourceId} value={r.resourceId}>
                        {r.resourceId} - {r.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Project Manager <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="currentProjectManager"
                  value={projectData.currentProjectManager}
                  onChange={handleChange}
                  required
                  disabled={!user?.organisationId}
                >
                  <option value="">Select Project Manager</option>
                  {resource.map((r) => (
                    <option key={r.resourceId} value={r.resourceId}>
                      {r.resourceId} - {r.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* ---- Submit ---- */}
          <div className="fields-btn-container">
            <Button
              variant="primary"
              type="submit"
              className="fields-submit"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Project"}
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  );
};

export default ProjectMaster;

// import { useEffect, useState } from "react";
// import { saveProjectDetails } from "../Api/ProjectMaster";
// import { Container, Form, Button, Row, Col } from "react-bootstrap";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import Sample14 from "../Components/Logo";
// import {
//   fetchCustomersByOrgId,
//   fetchProjectTypes,
//   fetchResourceByOrgId,
//   fetchCompanyCodesById,
// } from "../Api/InvoiceApi";
// import { useAuth } from "../Context/AuthContext";
// import axios from "axios";
// import { Base_URL } from "../url";

// const ProjectMaster = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);

//   const userDetails = JSON.parse(localStorage.getItem("userDetails"));
//   const userId = userDetails?.userId;
//   const orgId = userDetails?.organisationId;

//   const [customer, setCustomer] = useState([]);
//   const [projectType, setProjectType] = useState([]);
//   const [resource, setResource] = useState([]);
//   const [company, setCompany] = useState([]);
//   const [status, setStatus] = useState([]);

//   const { user } = useAuth();

//   const [projectData, setProjectData] = useState({
//     prTitle: "",
//     prDescription: "",
//     prTags: "",
//     prStartDate: "",
//     prEndDate: "",
//     prClient: "",
//     prTypes: "",
//     usersId: String(userId) || "",
//     orgId: String(orgId) || "",
//     teamAssigned: "",
//     projectStatus: "",
//     projectCategory: "",
//     comments: "",
//     salespersonCode: "",
//     currentProjectManager: "",
//     organisationId: user?.organisationId,
//     companyCode: "",
//     projectPriority: "", // ✅ new field
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setProjectData((prev) => ({ ...prev, [name]: value }));
//   };

//   const fetchDropdownData = async () => {
//     try {
//       const res = await fetchCustomersByOrgId(user?.organisationId);
//       const res1 = await fetchProjectTypes(user?.organisationId);
//       const res2 = await fetchResourceByOrgId(user?.organisationId);
//       const res3 = await fetchCompanyCodesById(user?.organisationId);
//       const res4 = await axios.get(`${Base_URL}/ProjectStatus`);

//       setCustomer(res || []);
//       setProjectType(res1 || []);
//       setResource(res2 || []);
//       setCompany(res3 || []);
//       setStatus(res4.data || []);
//     } catch (error) {
//       console.error("Error fetching dropdown data:", error);
//       setCustomer([]);
//       setProjectType([]);
//       setResource([]);
//       setCompany([]);
//       setStatus([]);
//     }
//   };

//   useEffect(() => {
//     fetchDropdownData();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       await saveProjectDetails(projectData, userId);
//       toast.success("🦄 Project Added Successfully");
//       console.log(projectData);
//       // Reset form after successful submission
//       setProjectData({
//         prTitle: "",
//         prDescription: "",
//         prTags: "",
//         prStartDate: "",
//         prEndDate: "",
//         prClient: "",
//         prTypes: "",
//         usersId: String(userId) || "",
//         orgId: String(orgId) || "",
//         teamAssigned: "",
//         projectStatus: "",
//         projectCategory: "",
//         comments: "",
//         salespersonCode: "",
//         currentProjectManager: "",
//         organisationId: user?.organisationId,
//         companyCode: "",
//         projectPriority: "", // ✅ reset field
//       });

//       navigate("/viewProjects");
//     } catch (error) {
//       toast.error(`🦄 Error saving project: ${error.message}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="main-content expand">
//       <Container fluid className="fields-container">
//         <h2 className="fields-title">Project Master</h2>

//         {loading && (
//           <div className="loading-overlay">
//             <Sample14 />
//           </div>
//         )}

//         <Form onSubmit={handleSubmit} className="fields-form">
//           {/* ---- Company Code ---- */}
//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Company Code <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="companyCode"
//                   value={projectData.companyCode}
//                   onChange={handleChange}
//                   required
//                   disabled={!user?.organisationId}
//                 >
//                   <option value="">Select Company Code</option>
//                   {company.map((p) => (
//                     <option key={p.companyCode} value={p.companyCode}>
//                       {p.companyCode} - {p.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Category <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="projectCategory"
//                   value={projectData.projectCategory}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     setProjectData((prev) => ({
//                       ...prev,
//                       projectCategory: value,
//                       // 🔹 Clear these if Internal is selected
//                       prClient: value === "Internal" ? "" : prev.prClient,
//                       salespersonCode:
//                         value === "Internal" ? "" : prev.salespersonCode,
//                     }));
//                   }}
//                   required
//                 >
//                   <option value="">Select Category</option>
//                   <option value="Internal">Internal</option>
//                   <option value="External">External</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* ---- Basic Details ---- */}
//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Project Title <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="prTitle"
//                   value={projectData.prTitle}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Project Description <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="prDescription"
//                   value={projectData.prDescription}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Project Tags</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="prTags"
//                   value={projectData.prTags}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* ---- Dates ---- */}
//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Start Date <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Control
//                   type="date"
//                   name="prStartDate"
//                   value={projectData.prStartDate}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   End Date <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Control
//                   type="date"
//                   name="prEndDate"
//                   value={projectData.prEndDate}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {projectData.projectCategory !== "Internal" && (
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Client Code <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Select
//                     name="prClient"
//                     value={projectData.prClient}
//                     onChange={handleChange}
//                     required={projectData.projectCategory === "External"}
//                     disabled={!user?.organisationId}
//                   >
//                     <option value="">Select Client Code</option>
//                     {customer.map((c) => (
//                       <option key={c.customerCode} value={c.customerCode}>
//                         {c.customerCode} - {c.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </Form.Group>
//               </Col>
//             )}
//           </Row>

//           {/* ---- Type, Team, Priority ---- */}
//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Project Type <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="prTypes"
//                   value={projectData.prTypes}
//                   onChange={handleChange}
//                   required
//                   disabled={!user?.organisationId}
//                 >
//                   <option value="">Select Project Type</option>
//                   {projectType.map((p) => (
//                     <option key={p.projectTypeId} value={p.projectTypeId}>
//                       {p.projectTypeId} - {p.projectTypeDesc}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Team Assigned</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="teamAssigned"
//                   value={projectData.teamAssigned}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             {/* ✅ New Dropdown for Project Priority */}
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Project Priority <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="projectPriority"
//                   value={projectData.projectPriority}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select Priority</option>
//                   <option value="Very High">Very High</option>
//                   <option value="High">High</option>
//                   <option value="Medium">Medium</option>
//                   <option value="Low">Low</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* ---- Remaining Fields ---- */}
//           <Row>
//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Status <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="projectStatus"
//                   value={projectData.projectStatus}
//                   onChange={handleChange}
//                   required
//                   disabled={!user?.organisationId}
//                 >
//                   <option value="">Select Project Status</option>
//                   {status.map((p) => (
//                     <option key={p.projectStatusId} value={p.projectStatusId}>
//                       {p.projectStatusId} - {p.projectStatusDesc}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Comments</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="comments"
//                   value={projectData.comments}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row>
//             {projectData.projectCategory !== "Internal" && (
//               <Col md={4}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Salesperson Code <span className="text-red">**</span>
//                   </Form.Label>
//                   <Form.Select
//                     name="salespersonCode"
//                     value={projectData.salespersonCode}
//                     onChange={handleChange}
//                     required={projectData.projectCategory === "External"}
//                     disabled={!user?.organisationId}
//                   >
//                     <option value="">Select SalesPerson Code</option>
//                     {resource.map((r) => (
//                       <option key={r.resourceId} value={r.resourceId}>
//                         {r.resourceId} - {r.name}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </Form.Group>
//               </Col>
//             )}

//             <Col md={4}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Project Manager <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="currentProjectManager"
//                   value={projectData.currentProjectManager}
//                   onChange={handleChange}
//                   required
//                   disabled={!user?.organisationId}
//                 >
//                   <option value="">Select Project Manager</option>
//                   {resource.map((r) => (
//                     <option key={r.resourceId} value={r.resourceId}>
//                       {r.resourceId} - {r.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* ---- Submit ---- */}
//           <div className="fields-btn-container">
//             <Button
//               variant="primary"
//               type="submit"
//               className="fields-submit"
//               disabled={loading}
//             >
//               {loading ? "Saving..." : "Save Project"}
//             </Button>
//           </div>
//         </Form>
//       </Container>
//     </div>
//   );
// };

// export default ProjectMaster;
